export default __webpack_public_path__ + "static/Barème-des-honoraires-PF-ee36e8da7de078eaeddb86521538c743.pdf";